import React from 'react';
import styled from 'styled-components';
import { minBp, maxBp } from 'src/lib/theme';
import Button from 'components/Button/Button';

export const Wrap = styled.div`
  padding: 40px 20px 120px;
  height: 100%;

  @media ${minBp('tablet')} {
    padding: 65px 40px 140px 40px;
  }

  @media ${minBp('tabletLarge')} {
    padding: 65px 40px 140px;
  }

  @media ${minBp('desktop')} {
    padding: 65px 160px 140px 40px;
  }

  .ScrollbarsCustom {
    position: relative;
    width: 100%;
    height: 100%;

    @media ${minBp('desktop')} {
      width: calc(100% + 15px);
    }
  }

  .ScrollbarsCustom-Wrapper {
    position: relative;
    top: 0px;
    left: 0px;
    bottom: 0px;
    right: 0px;

    @media ${maxBp('desktop')} {
      overflow: inherit !important;
      position: relative !important;
    }

    @media ${minBp('desktop')} {
      right: 10px;
      overflow: hidden;
    }
  }

  .ScrollbarsCustom-Scroller {
    position: relative;
    top: 0px;
    left: 0px;
    bottom: 0px;
    right: 0px;

    @media ${maxBp('desktop')} {
      position: relative !important;
      overflow: inherit !important;
    }

    @media ${minBp('desktop')} {
      padding-right: 15px;
      overflow: hidden scroll;
    }
  }

  .ScrollbarsCustom-Content {
    box-sizing: border-box;
    padding: 0.05px;
    min-height: 100%;
    min-width: 100%;

    @media ${minBp('desktop')} {
      padding-bottom: 40px !important;
    }
  }

  .ScrollbarsCustom-TrackY {
    position: absolute;
    overflow: hidden;
    border-radius: 4px;
    user-select: none;
    width: 10px;
    right: -20px;
    top: 0;
    height: calc(100% - 40px);
    background: #d0cfd0;
  }

  .ScrollbarsCustom-ThumbY {
    touch-action: none;
    cursor: pointer;
    border-radius: 4px;
    width: 100%;
    height: 385.054px;
    transform: translateY(0px);
    background-color: #585a5f;
  }
`;

export const Title = styled.h3`
  margin: 0 0 5px;
  text-transform: uppercase;
  line-height: 1.25;
  font-size: 20px;

  @media ${minBp('tabletLarge')} {
    font-size: 25px;
    margin: 0 0 10px;
  }
`;

export const Description = styled.p`
  font-size: 12px;
  margin: 0 0 10px;
  line-height: 1.25;

  @media ${minBp('tabletLarge')} {
    margin: 0 0 25px;
    color: #000;
    font-size: 15px;
    line-height: 1.4;
  }
`;

export const Heading = styled.div`
  text-transform: uppercase;
  font-size: 14px;
  color: black;
  border-bottom: 1px solid #ccc;
  padding: 5px;
  margin: 0 0 15px;
`;

export const Actions = styled.div`
  margin-top: 40px;
  display: flex;
`;

export const ConfirmButton = styled(Button)`
  margin-right: 20px;
  height: 50px;
  font-size: 13px;
  padding: 0 37px;

  @media ${minBp('tabletLarge')} {
    font-size: 14px;
  }

  &:disabled {
    opacity: 1;
    background-color: #a7a9ac;
  }
`;

export const CancelButton = styled(Button)`
  color: #000;
  text-decoration: underline;
  background: transparent;
  height: 50px;
  font-size: 13px;
  padding: 0 7px;

  @media ${minBp('tabletLarge')} {
    font-size: 14px;
  }

  &:hover:not(:disabled), &:focus {
    background: transparent;
  }
`;
